import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getFirestore, collection, getDocs } from 'firebase/firestore'
import { getApp } from 'firebase/app'
import '../assets/css/projectscreen.css'
import SideBar from '../components/sideBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'

const ProjectsScreen = ({ language }) => {
  const db = getFirestore(getApp())
  const [projects, setProjects] = useState([])
  const sortedProjects = projects.sort((a, b) => a.order - b.order);

    const [sidebarVisible, setSidebarVisible] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    const fetchProjects = async () => {
      const querySnapshot = await getDocs(collection(db, 'Projects'))
      const projectsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      setProjects(projectsList)
    }

    fetchProjects()
  }, [db])
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };
  const handleProjectClick = projectId => {
    navigate(`/projects/${projectId}`)
  }

  return (
    <div className='projects-container'>
            <button
        onClick={toggleSidebar}
        className={`toggle-sidebar-button ${sidebarVisible ? 'sidebar-visible' : ''}`}
      >
        {sidebarVisible ? '\u003C' : '\u003E'}
      </button>
      <div className={`sidebar ${sidebarVisible ? 'translate-x-0' : '-translate-x-full'}`}>
        <SideBar />
      </div>
      <div className='projects-list'>
        
      {sortedProjects.map((project, index) => (
          <div
            key={index}
            className='project-item'
            onClick={() => handleProjectClick(project.id)}
          >
            <h2 className='project-name font-bold'>{project.name}</h2>
            <p className='project-category'>{project.category}</p>
            {project.profileImage && (
              <>
                <img
                  src={project.profileImage}
                  alt={project.name}
                  className='project-profileimage'
                />
                <div className='overlay'>
                  <FontAwesomeIcon icon={faMagnifyingGlass} className='icon' />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProjectsScreen
